

















export default {
  name: 'CopyStakeStreamerDisclaimer'
};
